interface FrameKeyEntry {
    type: 'joint' | 'muscle' | 'time';
    axis?: 'x' | 'y' | 'z';
}

export const frameKeyMap: { [key: string]: FrameKeyEntry } = {
    "время": { type: 'time' },

    // Суставы / кости (Mixamo)
    "позвоночник_наклон_в_стороны": { type: 'joint', axis: 'z' }, // Spine
    "позвоночник_наклон_вперед": { type: 'joint', axis: 'y' }, // Spine
    "позвоночник_поворот": { type: 'joint', axis: 'x' }, // Spine

    "тазобедренный_сустав_л_сгибание": { type: 'joint', axis: 'x' }, // LeftUpLeg
    "тазобедренный_сустав_л_отведение": { type: 'joint', axis: 'z' }, // LeftUpLeg
    "коленный_сустав_л_сгибание": { type: 'joint', axis: 'x' }, // LeftLeg
    "голеностопный_сустав_л_сгибание": { type: 'joint', axis: 'x' }, // LeftFoot
    "голеностопный_сустав_л_отведение": { type: 'joint', axis: 'z' }, // RightFoo

    "тазобедренный_сустав_п_сгибание": { type: 'joint', axis: 'x' }, // RightUpLeg
    "тазобедренный_сустав_п_отведение": { type: 'joint', axis: 'z' }, // RightUpLeg
    "коленный_сустав_п_сгибание": { type: 'joint', axis: 'x' }, // RightLeg
    "голеностопный_сустав_п_сгибание": { type: 'joint', axis: 'x' }, // RightFoot
    "голеностопный_сустав_п_отведение": { type: 'joint', axis: 'z' }, // RightFoo

    "плечевой_сустав_л_сгибание": { type: 'joint', axis: 'z' }, // LeftArm
    "плечевой_сустав_л_подъем": { type: 'joint', axis: 'x' }, // LeftArm
    "локтевой_сустав_л_сгибание": { type: 'joint', axis: 'x' }, // LeftForeArm
    "лучезапястный_сустав_л_отведение": { type: 'joint', axis: 'x' }, // LeftHand
    "лучезапястный_сустав_л_сгибание": { type: 'joint', axis: 'z' }, // LeftHand

    "плечевой_сустав_п_сгибание": { type: 'joint', axis: 'z' }, // RightArm
    "плечевой_сустав_п_подъем": { type: 'joint', axis: 'x' }, // RightArm
    "локтевой_сустав_п_сгибание": { type: 'joint', axis: 'x' }, // RightForeArm
    "лучезапястный_сустав_п_отведение": { type: 'joint', axis: 'x' }, // RightHand
    "лучезапястный_сустав_п_сгибание": { type: 'joint', axis: 'z' },


    // Мышцы (право)
    "средняя_ягодичная_мышца_п": { type: 'muscle' },
    "двуглавая_мышца_бедра_длинная_г_п": { type: 'muscle' },
    "двуглавая_мышца_бедра_короткая_г_п": { type: 'muscle' },
    "портняжная_мышца_п": { type: 'muscle' },
    "большая_приводящая_мышца_п": { type: 'muscle' },
    "широкий_напрягатель_фасции_п": { type: 'muscle' },
    "гребенчатая_мышца_п": { type: 'muscle' },
    "тонкая_мышца_п": { type: 'muscle' },
    "большая_ягодичная_мышца_п": { type: 'muscle' },
    "подвздошная_мышца_п": { type: 'muscle' },
    "поясничная_мышца_п": { type: 'muscle' },
    //"четырехглавая_мышца_бедра_п": { type: 'muscle' },
    "близнецовая_мышца_п": { type: 'muscle' },
    "грушевидная_мышца_п": { type: 'muscle' },
    "прямая_мышца_бедра_п": { type: 'muscle' },
    "широкая_промежуточная_мышца_п": { type: 'muscle' },
    "медиальная_икроножная_мышца_п": { type: 'muscle' },
    "камбаловидная_мышца_п": { type: 'muscle' },
    "задняя_большеберцовая_мышца_п": { type: 'muscle' },
    "передняя_большеберцовая_мышца_п": { type: 'muscle' },

    // Мышцы (лево)
    "средняя_ягодичная_мышца_л": { type: 'muscle' },
    "двуглавая_мышца_бедра_длинная_г_л": { type: 'muscle' },
    "двуглавая_мышца_бедра_короткая_г_л": { type: 'muscle' },
    "портняжная_мышца_л": { type: 'muscle' },
    "большая_приводящая_мышца_л": { type: 'muscle' },
    "широкий_напрягатель_фасции_л": { type: 'muscle' },
    "гребенчатая_мышца_л": { type: 'muscle' },
    "тонкая_мышца_л": { type: 'muscle' },
    "большая_ягодичная_мышца_л": { type: 'muscle' },
    "подвздошная_мышца_л": { type: 'muscle' },
    "поясничная_мышца_л": { type: 'muscle' },
    //"четырехглавая_мышца_бедра_л": { type: 'muscle' },
    "близнецовая_мышца_л": { type: 'muscle' },
    "грушевидная_мышца_л": { type: 'muscle' },
    "прямая_мышца_бедра_л": { type: 'muscle' },
    "широкая_промежуточная_мышца_л": { type: 'muscle' },
    "медиальная_икроножная_мышца_л": { type: 'muscle' },
    "камбаловидная_мышца_л": { type: 'muscle' },
    "задняя_большеберцовая_мышца_л": { type: 'muscle' },
    "передняя_большеберцовая_мышца_л": { type: 'muscle' },

    // Мышцы корпуса
    "мышцы_выпрямляющие_позвоночник_п": { type: 'muscle' },
    "мышцы_выпрямляющие_позвоночник_л": { type: 'muscle' },
    "внутренние_косые_мышцы_п": { type: 'muscle' },
    "внутренние_косые_мышцы_л": { type: 'muscle' },
    "внешние_косые_мышцы_п": { type: 'muscle' },
    "внешние_косые_мышцы_л": { type: 'muscle' },

    // Плечевой пояс (право)
    "дельтовидная_мышца_п": { type: 'muscle' },
    "надостная_мышца_п": { type: 'muscle' },
    "подостная_мышца_п": { type: 'muscle' },
    "подлопаточная_мышца_п": { type: 'muscle' },
    "малая_круглая_мышца_п": { type: 'muscle' },
    "большая_круглая_мышца_п": { type: 'muscle' },
    "большая_грудная_мышца_п": { type: 'muscle' },
    "широчайшая_мышца_спины_п": { type: 'muscle' },
    "клювовидно-плечевая_мышца_п": { type: 'muscle' },
    "трехглавая_мышца_длинная_г_п": { type: 'muscle' },
    "трехглавая_мышца_латеральная_г_п": { type: 'muscle' },
    "трехглавая_мышца_средняя_г_п": { type: 'muscle' },
    "локтевая_мышца_п": { type: 'muscle' },
    "двуглавая_мышца_длинная_г_п": { type: 'muscle' },
    "двуглавая_мышца_короткая_г_п": { type: 'muscle' },
    "плечевая_мышца_п": { type: 'muscle' },
    "плечелучевая_мышца_п": { type: 'muscle' },
    "мышца_круглый_пронатор_п": { type: 'muscle' },

    // Плечевой пояс (лево)
    "дельтовидная_мышца_л": { type: 'muscle' },
    "надостная_мышца_л": { type: 'muscle' },
    "подостная_мышца_л": { type: 'muscle' },
    "подлопаточная_мышца_л": { type: 'muscle' },
    "малая_круглая_мышца_л": { type: 'muscle' },
    "большая_круглая_мышца_л": { type: 'muscle' },
    "большая_грудная_мышца_л": { type: 'muscle' },
    "широчайшая_мышца_спины_л": { type: 'muscle' },
    "клювовидно-плечевая_мышца_л": { type: 'muscle' },
    "трехглавая_мышца_длинная_г_л": { type: 'muscle' },
    "трехглавая_мышца_латеральная_г_л": { type: 'muscle' },
    "трехглавая_мышца_средняя_г_л": { type: 'muscle' },
    "локтевая_мышца_л": { type: 'muscle' },
    "двуглавая_мышца_длинная_г_л": { type: 'muscle' },
    "двуглавая_мышца_короткая_г_л": { type: 'muscle' },
    "плечевая_мышца_л": { type: 'muscle' },
    "плечелучевая_мышца_л": { type: 'muscle' },
    "мышца_круглый_пронатор_л": { type: 'muscle' },
};
/** Нормировка активности мышц (Н·с⁻¹ → [0..1]) */
export const muscleNormalization: Record<string, number> = {
    // Право
    "средняя_ягодичная_мышца_п": 1500,
    "двуглавая_мышца_бедра_длинная_г_п": 1200,
    "двуглавая_мышца_бедра_короткая_г_п": 900,
    "портняжная_мышца_п": 400,
    "большая_приводящая_мышца_п": 1600,
    "широкий_напрягатель_фасции_п": 600,
    "гребенчатая_мышца_п": 500,
    "тонкая_мышца_п": 300,
    "большая_ягодичная_мышца_п": 2500,
    "подвздошная_мышца_п": 1000,
    "поясничная_мышца_п": 1000,
    "близнецовая_мышца_п": 400,
    "грушевидная_мышца_п": 500,
    "прямая_мышца_бедра_п": 1500,
    "широкая_промежуточная_мышца_п": 1400,
    "медиальная_икроножная_мышца_п": 1800,
    "камбаловидная_мышца_п": 1600,
    "задняя_большеберцовая_мышца_п": 700,
    "передняя_большеберцовая_мышца_п": 800,

    // Лево
    "средняя_ягодичная_мышца_л": 1500,
    "двуглавая_мышца_бедра_длинная_г_л": 1200,
    "двуглавая_мышца_бедра_короткая_г_л": 900,
    "портняжная_мышца_л": 400,
    "большая_приводящая_мышца_л": 1600,
    "широкий_напрягатель_фасции_л": 600,
    "гребенчатая_мышца_л": 500,
    "тонкая_мышца_л": 300,
    "большая_ягодичная_мышца_л": 2500,
    "подвздошная_мышца_л": 1000,
    "поясничная_мышца_л": 1000,
    "близнецовая_мышца_л": 400,
    "грушевидная_мышца_л": 500,
    "прямая_мышца_бедра_л": 1500,
    "широкая_промежуточная_мышца_л": 1400,
    "медиальная_икроножная_мышца_л": 1800,
    "камбаловидная_мышца_л": 1600,
    "задняя_большеберцовая_мышца_л": 700,
    "передняя_большеберцовая_мышца_л": 800,

    // Корпус
    "мышцы_выпрямляющие_позвоночник_п": 1200,
    "мышцы_выпрямляющие_позвоночник_л": 1200,
    "внутренние_косые_мышцы_п": 900,
    "внутренние_косые_мышцы_л": 900,
    "внешние_косые_мышцы_п": 900,
    "внешние_косые_мышцы_л": 900,

    // Плечевой пояс (примерные значения)
    "дельтовидная_мышца_п": 1000,
    "надостная_мышца_п": 600,
    "подостная_мышца_п": 600,
    "подлопаточная_мышца_п": 700,
    "малая_круглая_мышца_п": 500,
    "большая_круглая_мышца_п": 800,
    "большая_грудная_мышца_п": 1600,
    "широчайшая_мышца_спины_п": 2000,
    "клювовидно-плечевая_мышца_п": 400,
    "трехглавая_мышца_длинная_г_п": 1000,
    "трехглавая_мышца_латеральная_г_п": 1000,
    "трехглавая_мышца_средняя_г_п": 1000,
    "локтевая_мышца_п": 400,
    "двуглавая_мышца_длинная_г_п": 1000,
    "двуглавая_мышца_короткая_г_п": 1000,
    "плечевая_мышца_п": 700,
    "плечелучевая_мышца_п": 600,
    "мышца_круглый_пронатор_п": 400,

    "дельтовидная_мышца_л": 1000,
    "надостная_мышца_л": 600,
    "подостная_мышца_л": 600,
    "подлопаточная_мышца_л": 700,
    "малая_круглая_мышца_л": 500,
    "большая_круглая_мышца_л": 800,
    "большая_грудная_мышца_л": 1600,
    "широчайшая_мышца_спины_л": 2000,
    "клювовидно-плечевая_мышца_л": 400,
    "трехглавая_мышца_длинная_г_л": 1000,
    "трехглавая_мышца_латеральная_г_л": 1000,
    "трехглавая_мышца_средняя_г_л": 1000,
    "локтевая_мышца_л": 400,
    "двуглавая_мышца_длинная_г_л": 1000,
    "двуглавая_мышца_короткая_г_л": 1000,
    "плечевая_мышца_л": 700,
    "плечелучевая_мышца_л": 600,
    "мышца_круглый_пронатор_л": 400,
};
